module.exports = "<p>\n  publicity-banner works!\n</p>\n"